export default {
  title: 'Opdateringer',
  fields: {
    app_version: 'App-version',
    description: 'Beskrivelse',
    created_at: 'Oprettet',
  },
};
